export default "__VITE_ASSET__80a2c1da__"